import { State } from '@meraki-internal/state';

export class QueryParamDrivenDrawerState extends State<{isOpen: boolean}> {
    setOpen = (isOpen: boolean) => {
        this.setState({ isOpen });
    };

    isOpen = () => {
        return Boolean(this.state?.isOpen);
    };
};
